import { render, staticRenderFns } from "./jujube_service.vue?vue&type=template&id=1f96bce4"
import script from "./jujube_service.vue?vue&type=script&lang=ts"
export * from "./jujube_service.vue?vue&type=script&lang=ts"
import style0 from "./jujube_service.vue?vue&type=style&index=0&id=1f96bce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports